<label [for]="name()" class="flex w-full flex-col gap-1">
  @if (label()) {
    @if (!labelTemplate()) {
      <span>{{ label() }}</span>
    } @else {
      <ng-container
        [ngTemplateOutlet]="labelTemplate()"
        [ngTemplateOutletContext]="{ $implicit: label() }" />
    }
  }

  <div class="flex flex-col">
    <ng-content></ng-content>
    <div class="flex gap-2" [ngClass]="{ 'flex-col': this.direction() === 'vertical' }">
      @for (valueToLabel of valuesToLabels(); track valueToLabel[1]) {
        <shared-ui-radio-button
          [label]="valueToLabel[1]"
          [radioButtonValue]="valueToLabel[0]"
          [formField]="$any(fieldTree())" />
      }
    </div>
  </div>
  @if (!isValid()) {
    @for (error of fieldState().errors(); track error) {
      <span class="text-error">{{ error.message }}</span>
    }
  }
</label>
